import { cn } from "@/lib/utils";

interface RightRailResizeHandleProps {
  onPointerDown: (event: React.PointerEvent<HTMLButtonElement>) => void;
  onDoubleClick?: () => void;
  className?: string;
}

/** Draggable grip on the left edge of the desktop right rail. */
export function RightRailResizeHandle({
  onPointerDown,
  onDoubleClick,
  className,
}: RightRailResizeHandleProps) {
  return (
    <button
      type="button"
      aria-label="Resize workspace panel"
      title="Drag to resize · double-click to reset"
      onPointerDown={onPointerDown}
      onDoubleClick={onDoubleClick}
      className={cn("right-rail-resize-handle", className)}
    />
  );
}
